'use strict';

const processInclude = require('BASE/util');

$(document).ready(() => {
    processInclude(require('./complaintForm/complaint'));
});
